import React from "react";
import { Pressable, Text } from "react-native";

type ScCheckboxProps = Readonly<{
  value: boolean;
  disabled?: boolean;
  onChange: (value: boolean) => void;
}>;

const ScCheckbox = ({ value, disabled, onChange }: ScCheckboxProps) => {
  return (
    <Pressable
      onPress={() => !disabled && onChange(!value)}
      className={`
        w-[18px] h-[18px]
        rounded-[4px]
        border-[1.5px]
        items-center justify-center
        ${value ? "bg-primary border-primary hover:opacity-90" : "border-ash-3 bg-white hover:bg-ash-3"}
        ${disabled ? "opacity-40" : ""}
      `}
    >
      {value && (
        <Text className="text-white text-[12px] font-semibold leading-[12px]">
          ✓
        </Text>
      )}
    </Pressable>
  );
};

export default ScCheckbox;
